import React from 'react';

const AvatarStatusBubble = ({ isOnline = false, children }) => {
  return (
    <div className="avatar-status-container">
      {children}
      {isOnline && <span className="status-buble"/>}
    </div>
  );
};

export default AvatarStatusBubble;
